import { render, staticRenderFns } from "./AdminCampaignFormDelete.vue?vue&type=template&id=40d60d6d&scoped=true"
import script from "./AdminCampaignFormDelete.vue?vue&type=script&lang=js"
export * from "./AdminCampaignFormDelete.vue?vue&type=script&lang=js"
import style0 from "./AdminCampaignFormDelete.vue?vue&type=style&index=0&id=40d60d6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d60d6d",
  null
  
)

export default component.exports